'use client';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'swiper/css';

import { motion } from 'framer-motion';
import Image from 'next/image';
import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import {
  CustomerAvatar1,
  CustomerAvatar2,
  CustomerAvatar3,
  CustomerAvatar4,
  CustomerAvatar5,
  CustomerAvatar6,
  CustomerAvatar7,
  CustomerAvatar8,
  CustomerAvatar9,
  CustomerAvatar10,
  HeroImage,
} from '@/assets';
import type { CardTestimionialProps } from '@/components/common/CardTestimionial';
import { CardTestimionial } from '@/components/common/CardTestimionial';
import Title from '@/components/common/Title';

const reviews: CardTestimionialProps[] = [
  {
    point: 5,
    review:
      'Trước đây, tôi gặp rất nhiều khó khăn trong việc theo dõi đơn hàng và quản lý nhân viên. Nhưng từ khi sử dụng Zump, mọi thứ trở nên dễ dàng hơn. Hệ thống đồng bộ dữ liệu thời gian thực giúp tôi kiểm soát hoạt động kinh doanh từ xa mà không cần lúc nào cũng có mặt tại cửa hàng!',
    avatar: CustomerAvatar1,
    name: 'Anh Minh',
    role: 'Chủ quán cafe tại TP.HCM',
  },
  {
    point: 5,
    review:
      'Việc xuất hóa đơn điện tử và hỗ trợ thanh toán đa dạng qua QR Code, MoMo, chuyển khoản… giúp tôi xử lý giao dịch một cách linh hoạt và nhanh chóng hơn trước rất nhiều.',
    avatar: CustomerAvatar10,
    name: 'Chị Hằng',
    role: 'Nhân viên thu ngân',
  },
  {
    point: 5,
    review:
      'Tôi thích nhất tính năng menu điện tử của Zump. Chỉ mất vài thao tác là có thể cập nhật giá và chương trình khuyến mãi. Không còn phải in lại menu giấy mỗi lần thay đổi giá, tiết kiệm rất nhiều thời gian và chi phí!',
    avatar: CustomerAvatar2,
    name: 'Chị Lan',
    role: 'Chủ quán ăn tại Đà Nẵng',
  },
  {
    point: 5,
    review:
      'Khách hàng của tôi rất thích tính năng gọi món qua QR Code. Họ có thể tự đặt món, theo dõi trạng thái đơn hàng mà không cần gọi nhân viên. Điều này không chỉ giúp quán vận hành trơn tru mà còn nâng cao trải nghiệm khách hàng!',
    avatar: CustomerAvatar3,
    name: 'Anh Huy',
    role: 'Chủ nhà hàng tại Hà Nội',
  },
  {
    point: 5,
    review:
      'Zump thực sự đã thay đổi cách mình làm việc. Việc tính tiền giờ đây không còn lo lắng về sai sót khi tính bằng tay. Hệ thống tự động, chính xác và giúp mình xử lý hóa đơn nhanh chóng. Mình cảm thấy yên tâm hơn khi làm việc nhờ sự tiện lợi này.',
    avatar: CustomerAvatar9,
    name: 'Anh Hoàng Nam',
    role: 'Nhân viên thu ngân',
  },
  {
    point: 5,
    review:
      'ôi từng gặp nhiều rắc rối với việc tính tiền nhầm, nhưng từ khi sử dụng Zump, mọi hóa đơn đều được tính toán tự động và chính xác. Hỗ trợ nhiều phương thức thanh toán như MoMo, QR Code rất tiện lợi cho khách hàng! ',
    avatar: CustomerAvatar4,
    name: 'Chị Mai',
    role: 'Chủ quán trà sữa tại Bình Dương',
  },
  {
    point: 5,
    review:
      'Trước đây, mỗi khi khách có yêu cầu thay đổi món thì mình luôn phải chạy lại để ghi chép. Nhưng giờ, nhờ có Zump, mọi thứ đều được cập nhật tức thì. Mình cảm thấy công việc nhẹ nhàng hơn rất nhiều và bớt căng thẳng, mệt mỏi khi quán đông khách.',
    avatar: CustomerAvatar8,
    name: 'Chị Minh Anh',
    role: 'Nhân viên phục vụ',
  },
  {
    point: 5,
    review:
      'Zump giúp tôi phân quyền nhân viên rõ ràng, theo dõi lịch sử tạo đơn của từng người, từ đó đánh giá hiệu suất làm việc dễ dàng hơn. Tôi cũng có thể kiểm soát quyền truy cập thông tin, đảm bảo bảo mật dữ liệu kinh doanh!',
    avatar: CustomerAvatar5,
    name: 'Anh Tùng',
    role: 'Chủ chuỗi nhà hàng tại TP.HCM',
  },
  {
    point: 5,
    review:
      'Tôi thích tính năng báo cáo của Zump. Nhờ hệ thống phân tích chi tiết doanh thu, chi phí, lợi nhuận theo ngày, tôi có thể đưa ra quyết định kinh doanh chính xác hơn. Biểu đồ trực quan giúp tôi theo dõi hiệu quả kinh doanh dễ dàng!',
    avatar: CustomerAvatar6,
    name: 'Chị Hạnh',
    role: 'Chủ tiệm bánh tại Cần Thơ',
  },
  {
    point: 5,
    review:
      'Trước đây, những yêu cầu đặc biệt của khách thường gây khó khăn cho bếp vì không được truyền đạt rõ ràng. Nhưng nhờ Zump, các ghi chú như "ít cay" hay "thêm đậu" hiện lên ngay trên hệ thống. Mình cảm thấy công việc bếp trở nên dễ dàng và chính xác hơn rất nhiều.',
    avatar: CustomerAvatar7,
    name: 'Anh Phong',
    role: 'Nhân viên bếp',
  },
];

export const TestimonialsSection = () => {
  return (
    <section
      id="testimonials"
      className="section relative overflow-hidden bg-primary-100/80"
    >
      <Image
        src={HeroImage}
        alt="Customer reviews"
        fill
        className="-z-10 object-cover"
      />
      <Title
        title="Khách hàng nói gì về Zump?"
        desc="Hãy để Zump lắng nghe câu chuyện của bạn – nơi mỗi chia sẻ trở thành động lực để kiến tạo nên những bước đột phá và khẳng định đẳng cấp thương hiệu."
      />
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <Swiper
          modules={[Autoplay]}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          freeMode
          loop
          centeredSlides
          slidesPerView="auto"
          speed={700}
          className="mt-16 w-full p-8"
        >
          {reviews.map((review, i) => (
            <SwiperSlide key={i} className="!max-w-96 p-5">
              <CardTestimionial {...review} />
            </SwiperSlide>
          ))}
        </Swiper>
      </motion.div>
      <div className="mx-auto mt-8 max-w-4xl px-5 text-center md:mt-12">
        <p className="text-center md:text-lg">
          Mỗi câu chuyện là một hành trình đầy cảm xúc - từ những khó khăn, lo
          lắng đến sự tự tin và niềm vui khi quản lý cửa hàng với Zump. Không
          chỉ giúp công việc trở nên rõ ràng, chính xác hơn, Zump còn là người
          bạn đồng hành, giúp chủ quán từng bước xây dựng một môi trường kinh
          doanh chuyên nghiệp, hiện đại và bền vững.
        </p>
      </div>
    </section>
  );
};
